import script from "./ShisetsuHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ShisetsuHome.vue?vue&type=script&setup=true&lang=js"

import "./ShisetsuHome.vue?vue&type=style&index=0&id=64f8a7f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f8a7f9"]])

export default __exports__